import { useTranslation } from 'react-i18next'
import BaseCursorPaging from 'src/components/CursorPaging/BaseCursorPaging'
import Empty from 'src/components/Empty'
import ModelCard from 'src/components/GenerationModel/ModelCard'
import type {
  GenerationModel,
  GenerationModelType,
} from 'src/services/apollo/generated/graphql'
import { useListUserLikedGenerationModels } from 'src/services/apollo/generation-model'
import { useShowNsfw } from 'src/services/helpers/preference'
import { useQs } from 'src/utils/qs'

export function UserLikedModelItemList(props: {
  userId: string
  modelType: GenerationModelType
}) {
  const { userId, modelType } = props
  const { t } = useTranslation(['artwork'])

  const [{ before, after }, setQs] = useQs()
  const [showNsfw] = useShowNsfw()

  return (
    <BaseCursorPaging
      useSWR={useListUserLikedGenerationModels}
      getConnection={r => r}
      pageSize={20}
      empty={<Empty description={t('artwork:no-content')} />}
      renderItem={(model: GenerationModel) => {
        return <ModelCard key={model.id} model={model} link />
      }}
      extraArgs={{
        userId,
        isNsfw: showNsfw ? undefined : false,
        types: [modelType],
      }}
      before={before}
      after={after}
      onCursorChange={setQs}
    />
  )
}
